import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { I18NextPipe } from 'angular-i18next';
import { ModalComponent } from 'mbs-ui-kit/modal/modal.component';
import { BuildAction } from 'mbs-ui-shared@constants';

import { ButtonComponent, ModalFooterDirective, SelectComponent } from 'mbs-ui-kit';

import { ReactiveFormsModule } from '@angular/forms';
import Brand from 'mbs-ui-shared@models/Brand';

@Component({
  selector: 'mbs-sidepanel-global-downloads-brands-modal',
  templateUrl: './brands-modal.component.html',
  imports: [ButtonComponent, ModalComponent, ReactiveFormsModule, SelectComponent, I18NextPipe, ModalFooterDirective]
})
export class BrandsModalComponent implements OnInit {
  private fb = inject(FormBuilder);
  private i18NPipe = inject(I18NextPipe);

  public licensedBrandList: Brand[] = [];
  public action: BuildAction = null;
  public brandForm = this.fb.group({
    brand: [null]
  });
  public confirmButtonText = null;
  public isActionActivated = false;

  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;

  ngOnInit() {
    const { licensedBrandList, action } = this.baseModal.data;
    this.action = action;
    this.brandForm.get('brand').patchValue(licensedBrandList[0]);
    this.licensedBrandList = licensedBrandList;
    this.confirmButtonText = this.getConfirmButtonText(action);
  }

  onActionButtonPressed(): void {
    const { brand } = this.brandForm.value;
    this.isActionActivated = true;

    this.baseModal.save(brand.id);
  }

  private getConfirmButtonText(action: BuildAction): string {
    switch (action) {
      case BuildAction.Download:
        return this.i18NPipe.transform('common.download', { format: 'title' });
      case BuildAction.CopyLink:
        return this.i18NPipe.transform('shared:buttons.copyLink', { format: 'title' });
      case BuildAction.CopyCommand:
        return this.i18NPipe.transform('shared:download-build.copyInstallationScript', { format: 'title' });
    }
  }
}
